import React from "react";
import {motion} from "motion/react";
import {LeftCloud} from "./LeftCloud";
import {PlaneIcon} from "../assets/svgComponents/PlaneIcon";
import globeImg from "../assets/images/LandingPageGlobe.png";
import {ChristianTag} from "./ChristianTag";
import {HannahTag} from "./HannahTag";
import {SophiaTag} from "./SophiaTag";
import BGirlMimoji from "../assets/images/BGirlMimoji.png";
import GirlMimoji from "../assets/images/GirlMimoji.png";
import IndianMimoji from "../assets/images/IndianMimoji.png";
import SunglassMimoji from "../assets/images/SunglassMimoji.png";
import {useNavigate} from "react-router-dom";

export default function LandingPage() {

    const navigate = useNavigate();

    return (
        <div
            className="bg-gradient-to-b from-[#f6f8ff] from-[43.912%] to-[#dde5ff] relative h-screen w-full overflow-hidden">
            {/* Logo oben links: farbiger Kasten + SVG-Icon (kein <img>) */}
            <motion.div
                className="absolute left-[102.4px] top-[102.4px] z-50 w-[59.908px] h-[59.908px]"
                initial={{opacity: 0, scale: 0.8}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.6, delay: 0.5, ease: "easeOut"}}
                onClick={() => navigate(-1)}
            >
                <div className="relative w-full h-full">
                    <div className="absolute inset-0 bg-[#aa76e1] rounded-[17.308px]"/>
                    <div className="absolute inset-[32.91%_30.02%_34.02%_31.64%]">
                        <PlaneIcon/>
                    </div>
                </div>
            </motion.div>

            {/* Center-Layout */}
            <div className="flex flex-col items-center justify-center relative h-full w-full">
                <div
                    className="box-border content-stretch flex flex-col gap-2.5 items-center justify-center px-[320px] relative h-full w-full">
                    <div
                        className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start p-[10px] relative w-[1078.82px]">
                        <div
                            className="box-border content-stretch flex items-center justify-start pl-0 pr-[100px] py-0 relative w-full">

                            {/* Linke schwebende Deko (SVG) */}
                            <motion.div
                                className="h-[140.833px] w-[189.656px] mr-[-100px] mt-[390px] relative z-10"
                                animate={{y: [0, -8, 0]}}
                                transition={{duration: 8, repeat: Infinity, ease: "easeInOut"}}
                            >
                                <LeftCloud/>
                            </motion.div>

                            {/* Mittelspalte */}
                            <div
                                className="box-border content-stretch flex flex-col gap-[21.667px] items-center justify-start mr-[-100px] relative w-[883.333px]">

                                {/* Hero-Cluster */}
                                <div
                                    className="grid-cols-[max-content] grid-rows-[max-content] inline-grid leading-[0] place-items-start relative shrink-0 overflow-hidden scale-90">
                                    {/* Hero-Hintergrund (war Background mit radialem Overlay → bleibt Div) */}
                                    <motion.div
                                        className="[grid-area:1_/_1] ml-[209.167px] mt-0 size-[267.5px] rounded-[12px] overflow-hidden absolute -z-10"
                                        initial={{opacity: 0, scale: 0.9}}
                                        animate={{opacity: 1, scale: 1}}
                                        transition={{duration: 0.33, delay: 0.03, ease: "easeOut"}}
                                    >
                                        {/* Globe als Hintergrund */}
                                        <img
                                            src={globeImg}
                                            alt="Landing Page Globe"
                                            className="w-full h-full object-cover"
                                        />

                                        {/* Overlay */}
                                        <div
                                            className="absolute inset-0 pointer-events-none"
                                            style={{
                                                background:
                                                    "radial-gradient(circle at center, rgba(246,248,255,0) 0%, rgba(246,248,255,0.7) 100%)"
                                            }}
                                        />
                                    </motion.div>
                                    )

                                    <motion.div
                                        className="[grid-area:1_/_1] ml-[156.667px] mt-[186.534px] w-[156px] h-[53px] z-15"
                                        initial={{opacity: 0, x: -30}}
                                        animate={{opacity: 1, x: 0}}
                                        transition={{duration: 0.27, delay: 0.73, ease: "easeOut"}}
                                    >
                                        <ChristianTag/>
                                    </motion.div>


                                    {/* Name-Tag: Hannah */}
                                    <motion.div
                                        className="[grid-area:1_/_1] ml-[223.646px] mt-[18.333px] w-[156px] h-[53px] z-15"
                                        initial={{opacity: 0, y: -30}}
                                        animate={{opacity: 1, y: 0}}
                                        transition={{duration: 0.27, delay: 0.83, ease: "easeOut"}}
                                    >
                                        <HannahTag/>
                                    </motion.div>


                                    {/* Name-Tag: Sophia */}
                                    <motion.div
                                        className="[grid-area:1_/_1] ml-[401.146px] mt-[143.333px] w-[156px] h-[53px] z-15"
                                        initial={{opacity: 0, x: 30}}
                                        animate={{opacity: 1, x: 0}}
                                        transition={{duration: 0.27, delay: 0.93, ease: "easeOut"}}
                                    >
                                        <SophiaTag/>
                                    </motion.div>


                                    {/* Schwebende Foto-Karten → echte Bilder (img-Platzhalter) */}
                                    <motion.div
                                        className="[grid-area:1_/_1] flex h-[106.17px] items-center justify-center ml-[519.167px] mt-[59.167px] relative w-[106.17px]"
                                        initial={{opacity: 0, scale: 0.8}}
                                        animate={{opacity: 1, scale: 1}}
                                        transition={{duration: 0.27, delay: 0.33, ease: "easeOut"}}
                                    >
                                        <div className="flex-none rotate-[9.993deg] relative">
                                            <div
                                                className="bg-[rgba(255,255,255,0.5)] pointer-events-none relative rounded-[25px] size-[91.667px] z-0">
                                                <div aria-hidden
                                                     className="absolute border-[1.667px] border-[rgba(255,255,255,0.5)] border-solid inset-0 rounded-[25px] shadow-[0_0_13.333px_rgba(0,0,0,0.09)]"/>
                                                <div
                                                    className="absolute inset-0 shadow-[0_0_10px_inset_rgba(255,255,255,0.8)]"/>
                                            </div>
                                            <img
                                                src={SunglassMimoji}
                                                alt="Card 1"
                                                className="absolute left-[9.167px] top-[9.167px] size-[73.333px] z-10 rounded-[25px] object-cover"
                                            />
                                        </div>
                                    </motion.div>

                                    <motion.div
                                        className="[grid-area:1_/_1] flex h-[104.247px] items-center justify-center ml-0 mt-[64.537px] relative w-[104.247px]"
                                        initial={{opacity: 0, scale: 0.8}}
                                        animate={{opacity: 1, scale: 1}}
                                        transition={{duration: 0.27, delay: 0.43, ease: "easeOut"}}
                                    >
                                        <div className="flex-none rotate-[351.463deg] relative">
                                            <div
                                                className="bg-[rgba(255,255,255,0.5)] pointer-events-none relative rounded-[25px] size-[91.667px] z-0">
                                                <div aria-hidden
                                                     className="absolute border-[1.667px] border-[rgba(255,255,255,0.5)] border-solid inset-0 rounded-[25px] shadow-[0_0_13.333px_rgba(0,0,0,0.09)]"/>
                                                <div
                                                    className="absolute inset-0 shadow-[0_0_10px_inset_rgba(255,255,255,0.8)]"/>
                                            </div>
                                            <img
                                                src={GirlMimoji}
                                                alt="Card 2"
                                                className="absolute left-[13.334px] top-[13.334px] size-[65px] z-10 rounded-[25px] object-cover"
                                            />
                                        </div>
                                    </motion.div>

                                    <motion.div
                                        className="[grid-area:1_/_1] ml-[86.296px] mt-[60px] relative size-[91.667px]"
                                        initial={{opacity: 0, scale: 0.8}}
                                        animate={{opacity: 1, scale: 1}}
                                        transition={{duration: 0.27, delay: 0.53, ease: "easeOut"}}
                                    >
                                        <div
                                            className="bg-[rgba(255,255,255,0.5)] pointer-events-none relative rounded-[25px] size-[91.667px] z-0">
                                            <div aria-hidden
                                                 className="absolute border-[1.667px] border-[rgba(255,255,255,0.5)] border-solid inset-0 rounded-[25px] shadow-[0_0_13.333px_rgba(0,0,0,0.09)]"/>
                                            <div
                                                className="absolute inset-0 shadow-[0_0_10px_inset_rgba(255,255,255,0.8)]"/>
                                        </div>
                                        <img
                                            src={BGirlMimoji}
                                            alt="Card 3"
                                            className="absolute left-[12.5px] top-[15px] size-[67.5px] z-10 rounded-[25px] object-cover"
                                        />
                                    </motion.div>

                                    <motion.div
                                        className="[grid-area:1_/_1] flex h-[106.17px] items-center justify-center ml-[610.167px] mt-[59.167px] relative w-[106.17px]"
                                        initial={{opacity: 0, scale: 0.8}}
                                        animate={{opacity: 1, scale: 1}}
                                        transition={{duration: 0.27, delay: 0.63, ease: "easeOut"}}
                                    >
                                        <div className="flex-none rotate-[350.141deg] relative">
                                            <div
                                                className="bg-[rgba(255,255,255,0.5)] pointer-events-none relative rounded-[25px] size-[91.667px] z-0">
                                                <div aria-hidden
                                                     className="absolute border-[1.667px] border-[rgba(255,255,255,0.5)] border-solid inset-0 rounded-[25px] shadow-[0_0_13.333px_rgba(0,0,0,0.09)]"/>
                                                <div
                                                    className="absolute inset-0 shadow-[0_0_10px_inset_rgba(255,255,255,0.8)]"/>
                                            </div>
                                            <img
                                                src={IndianMimoji}
                                                alt="Card 4"
                                                className="absolute left-[12.5px] top-[15px] size-[67.5px] z-10 rounded-[25px] object-cover"
                                            />
                                        </div>
                                    </motion.div>
                                </div>

                                {/* Subline + Headline + CTA */}
                                <div
                                    className="content-stretch flex flex-col gap-[44.167px] items-center justify-start w-full">
                                    <div className="content-stretch flex flex-col gap-[11.667px] items-center w-full">
                                        <motion.div
                                            className="font-['Outfit',_sans-serif] font-medium text-[#858ca7] text-[20px] text-center tracking-[-0.44px] w-full"
                                            initial={{opacity: 0, y: -50}}
                                            animate={{opacity: 1, y: 0}}
                                            transition={{duration: 0.3, delay: 1.07, ease: "easeOut"}}
                                        >
                                            <p>Plan your trip together with your friends.</p>
                                        </motion.div>

                                        <div
                                            className="content-stretch flex font-['Outfit',_sans-serif] font-bold gap-[11.667px] items-center leading-[0] text-[100px] text-center tracking-[-2.2px] w-full justify-center">
                                            <motion.div
                                                className="text-[#232323]"
                                                initial={{opacity: 0, y: -50}}
                                                animate={{opacity: 1, y: 0}}
                                                transition={{duration: 0.3, delay: 1.17, ease: "easeOut"}}
                                            >
                                                <p className="whitespace-pre">Plan That Trip.</p>
                                            </motion.div>
                                            <motion.div
                                                className="bg-clip-text bg-gradient-to-l from-[#b282e5] to-[#b282e547] z-20"
                                                style={{WebkitTextFillColor: "transparent"}}
                                                initial={{opacity: 0, y: -50}}
                                                animate={{opacity: 1, y: 0}}
                                                transition={{duration: 0.3, delay: 1.23, ease: "easeOut"}}
                                            >
                                                <svg width="261" height="87" viewBox="0 0 261 87" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M0.323132 85V0.279996H13.5231L53.7231 51.76V0.279996H72.5631V85H58.7631L19.1631 34.24V85H0.323132ZM112.677 86.32C94.5569 86.32 80.7569 73 80.7569 55.72C80.7569 38.44 94.4369 25.36 112.677 25.36C130.797 25.36 144.597 38.44 144.597 55.72C144.597 73.12 130.917 86.32 112.677 86.32ZM112.677 69.64C120.597 69.64 125.877 64 125.877 55.72C125.877 47.56 120.477 42.04 112.677 42.04C104.877 42.04 99.4769 47.68 99.4769 55.84C99.4769 64 104.877 69.64 112.677 69.64ZM164.206 85L144.046 26.68H162.046L172.006 60.52L183.046 26.68H197.926L208.966 60.52L219.046 26.68H237.046L216.886 85H201.886L190.486 51.4L179.086 85H164.206ZM249.86 86.32C243.5 86.32 238.94 81.52 238.94 75.28C238.94 69.04 243.5 64.12 249.86 64.12C256.22 64.12 260.78 69.04 260.78 75.28C260.78 81.52 256.22 86.32 249.86 86.32Z"
                                                        fill="url(#paint0_linear_40_542)"/>
                                                    <defs>
                                                        <linearGradient id="paint0_linear_40_542" x1="268" y1="40.5"
                                                                        x2="-8" y2="40.5"
                                                                        gradientUnits="userSpaceOnUse">
                                                            <stop stop-color="#B282E5"/>
                                                            <stop offset="1" stop-color="#B282E5" stop-opacity="0.28"/>
                                                        </linearGradient>
                                                    </defs>
                                                </svg>

                                            </motion.div>
                                        </div>
                                    </div>

                                    {/* CTA-Button (Icon als SVG, kein <img>) */}
                                    <motion.button
                                        onClick={() => navigate("/sessions")}
                                        className="relative bg-[#b282e5] box-border flex gap-[13.696px] h-[52.5px] items-center pl-[29.167px] pr-[26.667px] py-[15.978px] rounded-[26.25px] w-[176.667px] overflow-hidden text-[#f6f8ff] font-['Space_Grotesk',_sans-serif] font-semibold text-[15.978px] tracking-[-0.8788px] shadow-md"
                                        initial={{opacity: 0, y: -50}}
                                        animate={{opacity: 1, y: 0}}
                                        transition={{duration: 0.3, delay: 1.17, ease: "easeOut"}}
                                        whileHover={{scale: 1.05, boxShadow: "0 8px 25px rgba(178,130,229,0.4)"}}
                                        whileTap={{scale: 0.98}}
                                    >
                                        <motion.span
                                            className="absolute inset-0 w-[200px] h-full bg-gradient-to-r from-transparent via-[#9365C5] to-transparent opacity-30 blur-sm"
                                            animate={{x: [-200, 376]}}
                                            transition={{
                                                duration: 2.5,
                                                repeat: Infinity,
                                                repeatDelay: 14.15,
                                                ease: "easeInOut"
                                            }}
                                        />
                                        <motion.span
                                            className="absolute inset-0 w-[150px] h-full bg-gradient-to-r from-transparent via-white to-transparent opacity-0 blur-sm"
                                            whileHover={{
                                                x: 326,
                                                opacity: 0.3,
                                                transition: {duration: 0.8, ease: "easeOut"}
                                            }}
                                        />
                                        <PlaneIcon/>
                                        <span className="relative z-10">Here we go</span>
                                    </motion.button>
                                </div>
                            </div>

                            <motion.div
                                className="h-[137.995px] w-[185.833px] mr-[-100px] mt-[155px] relative z-0"
                                animate={{y: [0, 12, 0]}}
                                transition={{duration: 10, repeat: Infinity, ease: "easeInOut", delay: 2}}
                            >
                                <LeftCloud/>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
